import defaults from '@mailobj-browser/front/js/selectors/defaults.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'

const credentialType = object(null, {
  sameOrigin: object(null, {
    credentials: 'same-origin'
  }),
  include: object(null, {
    credentials: 'include'
  })
})

export default (
  url,
  document = defaults.document
) => {

  const { location } = document
  const { protocol } = location

  if (protocol !== 'file:') {
    return credentialType.sameOrigin
  }

  const { href: baseHref } = one('base', document) ?? location

  const baseUrl = new URL(baseHref)
  const testUrl = new URL(url)

  if (baseUrl.origin === testUrl.origin) {
    return credentialType.include
  }

  return credentialType.sameOrigin
}
